var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../../element-factory";
import { ReactSurveyElement } from "../../../reactquestion_element";
var SurveyQuestionMatrixDynamicDragDropIcon = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixDynamicDragDropIcon, _super);
    function SurveyQuestionMatrixDynamicDragDropIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionMatrixDynamicDragDropIcon.prototype, "question", {
        get: function () {
            return this.props.item.data.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixDynamicDragDropIcon.prototype, "row", {
        get: function () {
            return this.props.item.data.row;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixDynamicDragDropIcon.prototype.renderElement = function () {
        var _this = this;
        return React.createElement("div", { onPointerDown: function (event) { _this.question.onPointerDown(event.nativeEvent, _this.row); } }, this.renderIcon());
    };
    SurveyQuestionMatrixDynamicDragDropIcon.prototype.renderIcon = function () {
        if (this.question.iconDragElement) {
            return (React.createElement("svg", { className: this.question.cssClasses.dragElementDecorator },
                React.createElement("use", { xlinkHref: this.question.iconDragElement })));
        }
        else {
            return (React.createElement("span", { className: this.question.cssClasses.iconDrag }));
        }
    };
    return SurveyQuestionMatrixDynamicDragDropIcon;
}(ReactSurveyElement));
export { SurveyQuestionMatrixDynamicDragDropIcon };
ReactElementFactory.Instance.registerElement("sv-matrix-drag-drop-icon", function (props) {
    return React.createElement(SurveyQuestionMatrixDynamicDragDropIcon, props);
});
